import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import './css/main.css'
import * as filters from './filters'
import { Lazyload } from 'vant';
// import VConsole from 'vconsole';
// const vConsole = new VConsole();
import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(Lazyload);
Vue.use(SlideVerify);

// 适配flex
import './utils/flexible.js';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
